module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "tochead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Glossary"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_01"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter One")])]), _vm._v(" Noble Purpose")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Two")])]), _vm._v(" In the Field")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Three")])]), _vm._v(" Behind Toothed Wire")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Four")])]), _vm._v(" Prison Camp Lines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Five")])]), _vm._v(" Gatekeeper")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Six")])]), _vm._v(" Princeton")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Seven")])]), _vm._v(" Standard-Bearer")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter Eight")])]), _vm._v(" The Long Day’s Task is Done")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_bma"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Appendix_I",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix I")])]), _vm._v(" The Christ of Mory")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Appendix_II",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix II")])]), _vm._v(" The Chestnuts")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Appendix_III",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tochang1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix III")])]), _vm._v(" A Voice from the Past")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_bma"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0